import styled from 'styled-components';

export const StyledContentCardContainer = styled.div`
  width: 100%;

  ${Styles.desktop} {
    align-items: center;
    display: flex;
    height: auto;
    justify-content: stretch;
  }

  .ab-feed {
    border: none;
    box-shadow: none;
    width: auto;
    z-index: ${Styles.zIndex.below};

    ${Styles.desktop} {
      display: flex;
      flex-flow: row wrap;
      margin: 0 auto;
    }

    .ab-feed-buttons-wrapper {
      display: none;
    }

    .ab-feed-body {
      border: none;
      box-shadow: none;
      max-width: 100vw;

      ${Styles.desktop} {
        display: flex;
        flex-flow: row wrap;
        max-width: 52.25rem;
        width: 100%;
      }

      .ab-card {
        ${Styles.desktop} {
          width: 24rem;
          margin-block-end: 1.25rem;
        }

        &:focus-within {
          outline: -webkit-focus-ring-color auto 5px;
          outline-color: -webkit-focus-ring-color;
          outline-style: auto;
          outline-width: 5px;
        }

        :nth-child(odd) {
          ${Styles.desktop} {
            margin-inline-end: 1.25rem;
          }
        }

        /* Hides braze content card's pinned and unread indicators */
        .ab-pinned-indicator,
        .ab-unread-indicator {
          display: none;
        }
      }
    }

    .ab-no-cards-message {
      display: none;
    }
  }
`;
